//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import CardexTable from "@/pages/Cardex/components/CardexTable.vue";
import CardexForm from "@/pages/Cardex/components/CardexForm.vue";
import { EventBus } from "@/event-bus.js";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "Cardex",
  components: {
    CardexTable,
    CardexForm,
  },
  props: {},
  mounted: function () {
    this.isLoading = true;
    let date = new Date();
    let drawerParams = {
      filter: {
        start_date: moment(date).format("YYYY-MM-DD"),
        end_date: moment(date).format("YYYY-MM-DD"),
      },
    };
    this.$store.commit("setSingleDate", drawerParams.filter.start_date);

    BackendServices.getAllCardexEntries(null, drawerParams).then((response) => {
      this.recordsTotal = response.headers["x-total-count"];
      if (Array.isArray(response.data)) {
        this.data = response.data;
      } else {
        this.data = [];
      }
      this.isLoading = false;
    });

    this.$store.commit("setDatePickerState", true);
    EventBus.$on("rightDrawerQueryAction", this.executeQueryAction);
  },
  data: () => ({
    editRowClicked: false,
    tableTab: "cardex",
    cardexEntry: {},
    data: [],
    filterState: null,
    retailer: null,
    insignia: null,
    type: null,
    date: null,
    fileType: null,
    separator: "cell",
    recordsTotal: 0,
    isLoading: false,
    productHierarchyElementId: null,
    storeHierarchyElementId: null,
    geoHierarchyElementId: null,
    productIds: null,
    storeIds: null,
    employeeIds: null,
  }),
  methods: {
    executeQueryAction: function () {
      this.askForData();
    },
    renderRightSide: function (event) {
      this.editRowClicked = true;
      this.cardexEntry = event;
    },

    async askForData(event = null) {
      //Resolver date, primeiro pedido vai sem, segundo com.
      let pagination = null;

      if (event == null) {
        pagination = null;
      } else {
        pagination = {
          page: event.pagination.page,
          rowsPerPage: event.pagination.rowsPerPage,
        };
      }

      this.isLoading = true;
      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          employee_id: this.employeeIds,
          start_date: this.date._i,
          end_date: this.date._i,
        },
      };

      //search in drawerParams for null values and delete them
      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }
      let result = await BackendServices.getAllCardexEntries(
        pagination,
        drawerParams
      );
      this.recordsTotal = result.headers["x-total-count"];
      if (Array.isArray(result.data)) {
        this.data = result.data;
      } else {
        this.data = [];
      }
      this.isLoading = false;
    },

    closeForm() {
      this.editRowClicked = false;
    },
    saveCardexEntry: function () {
      let operation = !this.cardexEntry.id
        ? BackendServices.createNewCardexEntry(this.cardexEntry)
        : BackendServices.updateExistingCardexEntry(this.cardexEntry);
      operation.then(() => window.location.reload());
    },
    exportFilteredCardex: function () {
      Feedback.warning("Exportação iniciada.");
      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          employee_id: this.employeeIds,
          start_date: this.date._i,
          end_date: this.date._i,
        },
      };

      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }
      BackendServices.downloadCardexList(drawerParams).then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "Cardex.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
  },
  watch: {
    "$store.getters.getProductHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let productHierarchy = Object.values(
          this.$store.getters.getProductHierarchy
        ).filter((i) => i.length > 0);
        this.productHierarchyElementId =
          productHierarchy[productHierarchy.length - 1];
      },
    },
    "$store.getters.getStoreHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let storeHierarchy = Object.values(
          this.$store.getters.getStoreHierarchy
        ).filter((i) => i.length > 0);
        this.storeHierarchyElementId =
          storeHierarchy[storeHierarchy.length - 1];
      },
    },
    "$store.getters.getGeographyHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let geoHierarchy = Object.values(
          this.$store.getters.getGeographyHierarchy
        ).filter((i) => i.length > 0);
        this.geoHierarchyElementId = geoHierarchy[geoHierarchy.length - 1];
      },
    },
    "$store.getters.getSingleDate": {
      immediate: true,
      deep: true,
      handler: function () {
        this.date = moment(this.$store.getters.getSingleDate, "YYYY/MM/DD");
      },
    },
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.productIds) {
          this.productIds = [];
        }
        if (this.$store.getters.getProductList.length) {
          this.productIds = [];
          this.productIds = this.$store.getters.getProductList;
        } else {
          this.productIds = null;
        }
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.storeIds) {
          this.storeIds = [];
        }
        if (this.$store.getters.getStoreList.length) {
          this.storeIds = [];
          this.storeIds = this.$store.getters.getStoreList;
        } else {
          this.storeIds = null;
        }
      },
    },
    "$store.getters.getEmployeeList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.employeeIds) {
          this.employeeIds = [];
        }

        if (this.$store.getters.getEmployeeList.length) {
          this.employeeIds = [...this.$store.getters.getEmployeeList]
        } else {
          this.employeeIds = null;
        }
      },
    },
  },
};

// askForData: function (event) {
//   this.isLoading = true;
//   BackendServices.getAllCardexEntries(
//     event.pagination,
//     event.filter,
//     this.productHierarchyElementId,
//     this.storeHierarchyElementId,
//     this.geoHierarchyElementId
//   ).then((response) => {
//     this.recordsTotal = response.headers["x-total-count"];
//     this.data = response.data;
//     this.isLoading = false;
//   });
